import { OrganizationCreateType, OrganizationEditType } from '@/shared/types'
import { getDateFormat } from '@/shared/utils'
import { DATE_FORMAT } from '@/shared/constants'

export class OrganizationDataMapper {
  static mapOrganizationCreationData = (
    organization: OrganizationCreateType
  ): FormData => {
    const {
      name,
      address,
      inn,
      phone,
      site,
      isTest,
      logo,
      modules,
      packageCount,
      blockAt,
    } = organization

    const formData = new FormData()

    formData.append('name', name)
    formData.append('address', address)
    formData.append('is_test', String(isTest))

    if (packageCount) {
      formData.append('package_count', String(packageCount))
    }

    if (blockAt) {
      formData.append(
        'block_at',
        getDateFormat(new Date(blockAt), DATE_FORMAT.dmyDot)
      )
    }

    if (inn) {
      formData.append('inn', inn)
    }

    if (phone) {
      formData.append('phone', phone)
    }

    if (site) {
      formData.append('site', site)
    }

    if (logo) {
      formData.append('logo', logo)
    }

    if (modules) {
      modules.forEach((module) => formData.append('modules[]', module))
    }

    return formData
  }

  static mapOrganizationEditionData = (
    organization: OrganizationEditType
  ): FormData => {
    const {
      name,
      address,
      logo,
      inn,
      isTest,
      phone,
      site,
      isBlocked,
      blockDate,
      packageCount,
      modules,
    } = organization

    const formData = new FormData()

    if (logo.length && logo[0].raw) {
      formData.append('logo', logo[0].raw)
    }

    formData.append('name', name)
    formData.append('address', address)
    formData.append('inn', inn ?? '')
    formData.append('is_test', String(isTest))
    formData.append('phone', phone ?? '')
    formData.append('site', site ?? '')
    formData.append('is_blocked', isBlocked.toString())
    formData.append(
      'block_at',
      getDateFormat(new Date(blockDate), DATE_FORMAT.dmyDot)
    )
    formData.append('package_count', packageCount.toString())
    modules.forEach((module) => formData.append('modules[]', module))
    if (modules.length === 0) {
      formData.append('modules[]', '')
    }

    return formData
  }
}
